import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { BannerType, BannerTypesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class BannerTypesDataService {

  private uri: string = `${environment.apiUrl}banner-types`;
  private cacheKey: string = 'bannerTypes.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getBannerType(id: number): Observable<BannerType|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getBannerTypes(parameters: {[param: string]: string | string[]}): Observable<BannerTypesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addBannerType(data: BannerType): Observable<BannerType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addBannerTypes(data: BannerType[]): Observable<BannerType[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateBannerType(data: BannerType): Observable<BannerType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateBannerTypes(data: BannerType[]): Observable<BannerType[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchBannerType(data: BannerType): Observable<BannerType|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchBannerTypes(data: BannerType[]): Observable<BannerType[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteBannerType(data: BannerType): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteBannerTypes(data: BannerType[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((bannerType) => {
      ids.push(bannerType.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
